global.moxie = require('../../../../node_modules/plupload/js/moxie.js');
const plupload = require('../../../../node_modules/plupload/js/plupload.min.js');

/* global planningActivities, plupload */
angular
  .module('cfn')
  .controller('bookingImportWizardController', bookingImportWizardController);

bookingImportWizardController.$inject = [
  '$rootScope',
  '$scope',
  'dialog',
  '$injector',
  '$timeout',
  '$filter',
  '$http',
  '$log',
  'externalAccounts',
  'BookinIsoXmlHttp',
  'bookingRenderService',
  'isFendt',
  'tracker',
];
function bookingImportWizardController(
  $rootScope,
  $scope,
  dialog,
  $injector,
  $timeout,
  $filter,
  $http,
  $log,
  externalAccounts,
  BookinIsoXmlHttp,
  bookingRenderService,
  isFendt,
  tracker
) {
  'use strict';

  // Wizard steps: upload > basedata > select tasks > match tasks > summary > confirmation

  // Allgemein
  var controller = this;
  var uploader;
  var MILLISECONDS_PER_YEAR = 31556952000;

  controller.helpDisplayed = false;
  controller.isTasksAllowed = false;
  controller.error = null;
  controller.processing = false;
  controller.importFile = null;
  controller.errorListVisible = false;
  controller.uploadResponse = null; // aka basedataResponse
  controller.taskListResponse = null;
  controller.basedataCurrent = {}; // selected basedata grid entries
  controller.basedataMatches = {}; // selected basedata entry matches
  controller.taskMatchResponse = null; // task list
  controller.matchTaskCurrent = null; // currently selected task
  controller.matchOperationsCurrent = []; // matches for currently selected task
  controller.importResponse = null;
  controller.status = {}; // displayed in basedata tab headings
  controller.isFendt = isFendt;
  controller.tab = {};

  controller.machines = [];
  controller.showMachines = 0;
  controller.operations = [];
  controller.taskState = [];

  _.each(enums.TaskStateEnum.options, function(option) {
    controller.taskState.push({
      key: option,
      value: enums.TaskStateEnum[option]
    });
  });

  // track both import variants
  if (controller.isFendt) {
      tracker.trackEvent('BOOKING_IMPORT_WIZARD', 'FENDT_IMPORT');
  } else {
      tracker.trackEvent('BOOKING_IMPORT_WIZARD', 'OLD_ISO_XML_IMPORT');
  }

  $http({
    method: 'GET',
    url: '/365FarmNet/rest/booking/isoxml/operations/templates'
  }).then(function(response) {
    //controller.operations=response;
    var k = 1;
    _.each(response.data, function(item) {
      controller.operations.push({
        key: k,
        activityName: item.activityName,
        templateName: item.templateName
      });
      k = k + 1;
    });

    initializeUploader();
  });

  controller.allSelect = function() {
    _.each(controller.taskListResponse.entries, function(item) {
      if ($scope.allSelected) {
        if (!item.$cfngrid_invalid && !item.$cfngrid_inactive)
          item.$cfngrid_selected = true;
      } else {
        item.$cfngrid_selected = false;
      }
    });
  };

  controller.lookupFendt = function() {
    if (controller.showMachines === 0) {
      $http({
        method: 'GET',
        url: '/365FarmNet/rest/core/machine/fendt',
        params: { serialnumber: true, isIsoXml: true }
      }).then(function(response) {
        _.each(response.data, function(machine) {
          controller.machines.push({
            serienNr: machine.serialnumber,
            name: machine.name
          });
        });

        if (controller.machines.length > 0) {
          controller.showMachines = 1;
          controller.info = $filter('i18n')(
            'fe.core.wizards.isoExport.info',
            'bitte eine Maschine auswählen.'
          );
          return;
        }
      });
    }

    controller.showMachines = 2;
    controller.error = $filter('i18n')(
      'fe.core.wizards.isoExport.error',
      'keine passende Maschine vorhanden.'
    );
  };

  controller.dataSets = [];
  controller.hasFendtCredentials = false;
  controller.selectedDataSetUuid = null;
  controller.dataSetGridController = null;

  controller.dataSetsLoad = function() {
    externalAccounts
      .hasCredentials('fendt.varioDoc')
      .then(function(hasCredentials) {
        if (!hasCredentials) {
          return;
        }

        controller.hasFendtCredentials = true;

        BookinIsoXmlHttp.allDataSets().then(function(dataSets) {
          _.each(dataSets, function(data) {
            if (data.taskState !== null && data.taskState !== undefined) {
              _.each(controller.taskState, function(taskState) {
                if (taskState.key === data.taskState)
                  data.taskState = taskState.value;
              });
            }
          });
          controller.dataSets = dataSets;
        });
      });
  };

  controller.dataSetsLoad();

  controller.dataSetsGridInit = function(gridController) {
    controller.dataSetGridController = gridController;
  };

  controller.dataSetsSelectionChange = function(dataSet) {
    var selectedRoles = $.map(
      $('#fendtSelectDataSetGrid').isolateScope().viewData,
      function(v) {
        if (v.$cfngrid_selected) controller.selectedDataSetUuid = v.id;
        controller.importFile = null;
      }
    );
  };

  controller.dataSetsClearSelection = function() {
    if (controller.dataSetGridController === null) {
      // controller not initialized yet
      return;
    }
    controller.dataSetGridController.clearSelection();
    controller.dataSetGridController.refresh();
  };

  var basedataStati = {
    ignore: {
      symbol: 'farmnet-minus4',
      title: $filter('i18n')(
        'fe.core.wizards.bookingImport.ignoreitem',
        'ignorieren (nicht importieren)'
      )
    },
    add: {
      symbol: 'farmnet-plus4',
      title: $filter('i18n')(
        'fe.core.wizards.bookingImport.additem',
        'hinzufügen'
      )
    },
    matched: {
      symbol: 'farmnet-shuffle2',
      title: $filter('i18n')(
        'fe.core.wizards.bookingImport.matched',
        'zugeordnet'
      )
    },
    automatched: {
      symbol: 'farmnet-checkmark3',
      title: $filter('i18n')(
        'fe.core.wizards.bookingImport.matched',
        'zugeordnet'
      )
    },
    warning: {
      symbol: 'farmnet-new',
      title: ''
    }
  };

  var grids = {}; // farm, farmMatch, field, fieldMatch, machine, machineMatch, person, personMatch, taskList, task, taskMatch

  controller.selectorButton = {
    text: {
      add: $filter('i18n')(
        'fe.core.wizards.bookingImport.addall',
        'alle hinzufügen'
      ),
      reset: $filter('i18n')(
        'fe.core.wizards.bookingImport.addallundo',
        'hinzufügen zurücksetzen'
      )
    },
    action: {
      add: function(type) {
        _.each(controller.uploadResponse[type].entities, function(entity) {
          if (!entity.match || entity.match.id.substr(-7) === ':ignore') {
            entity.match = controller.uploadResponse[type].standard[0]; // add
          }
        });
        controller.prepareTabHeaderStatus(type);
        controller.selectorButton[type] = {
          symbol: basedataStati.ignore.symbol,
          tooltip: controller.selectorButton.text.reset,
          action: controller.selectorButton.action.reset
        };
      },
      reset: function(type) {
        _.each(controller.uploadResponse[type].entities, function(entity) {
          if (entity.match && entity.match.id.substr(-4) === ':add') {
            entity.match = null;
          }
        });
        controller.prepareTabHeaderStatus(type);
        controller.selectorButton[type] = {
          symbol: basedataStati.add.symbol,
          tooltip: controller.selectorButton.text.add,
          action: controller.selectorButton.action.add
        };
      }
    }
  };
  controller.selectorButton.farm = {
    symbol: basedataStati.add.symbol,
    tooltip: controller.selectorButton.text.add,
    action: controller.selectorButton.action.add
  };
  controller.selectorButton.field = {
    symbol: basedataStati.add.symbol,
    tooltip: controller.selectorButton.text.add,
    action: controller.selectorButton.action.add
  };
  controller.selectorButton.machine = {
    symbol: basedataStati.add.symbol,
    tooltip: controller.selectorButton.text.add,
    action: controller.selectorButton.action.add
  };
  controller.selectorButton.person = {
    symbol: basedataStati.add.symbol,
    tooltip: controller.selectorButton.text.add,
    action: controller.selectorButton.action.add
  };

  // ========== GRID FUNCTIONS BEGIN ==========

  controller.gridInit = function(grid, scope) {
    if (grid && scope && scope.name) {
      grids[scope.name] = grid;
    }
  };

  controller.gridBasedataSelect = function(entity, id) {
    var type = id.split(':')[0];
    if (
      controller.basedataCurrent[type] &&
      controller.basedataCurrent[type].id === id
    ) {
      // clicked again, do nothing
    } else {
      // clicked first time
      controller.basedataCurrent[type] = entity;

      var matches = [];
      // add standard entries (add, ignore)
      _.each(controller.uploadResponse[type].standard, function(entry) {
        matches.push(entry);
      });
      // add the calculated matches that are specific to this entry
      _.each(entity.matches, function(match) {
        matches.push(match);
      });
      // add all entries from the database
      _.each(controller.uploadResponse[type].basedata, function(entry) {
        matches.push(entry);
      });
      _.each(matches, function(match) {
        delete match.$cfngrid_selected;
      }); // clear selected flag
      matches = _.unique(matches, function(match) {
        return match.id;
      }); // remove duplicate entries
      if (entity.match) {
        // set the selected flag
        var m = _.find(matches, function(match) {
          return match.id === entity.match.id;
        });
        if (m) {
          m.$cfngrid_selected = true;
        }
      }
      controller.basedataMatches[type] = matches;
    }
  };

  controller.gridBasedataSelectMatch = function(match, id) {
    // $log.log('gridBasedataSelectMatch', id, match);
    var type = id.split(':')[0];
    var entity = controller.basedataCurrent[type];
    if (!entity) return;
    if (type === 'farm') {
      controller.swapFarmFields(entity, match);
    } // deactivate a farm's fields if necessary
    if (entity.match && entity.match.id === match.id) {
      // selecting a match a second time, deselects it
      match.$cfngrid_selected = false;
      entity.match = null;
    } else {
      entity.match = match;
      if (type !== 'farm') {
        controller.deselectDuplicateMatchInBasedata(type, entity.id, match.id);
      } // 1-to-many only for farms
    }
    controller.prepareTabHeaderStatus(type);
  };

  controller.swapFarmFields = function(entity, match) {
    if (!_.has(controller.uploadResponse.field, 'ignored'))
      controller.uploadResponse.field.ignored = [];

    var activateFields = function() {
      // split fields from ignored into two arrays (belonging to farm and not belonging to farm)
      var ab = _.partition(controller.uploadResponse.field.ignored, function(
        e
      ) {
        return e.companyIsoId === entity.isoId;
      });

      // replace ignored array with fields that do not belong to farm
      controller.uploadResponse.field.ignored = ab[1];

      // push fields in the active field array onto the belong-to-farm array
      _.each(controller.uploadResponse.field.entities, function(e) {
        ab[0].push(e);
      });
      controller.uploadResponse.field.entities = ab[0]; // assign new value which triggers angular to update view
    };

    var ignoreFields = function(isoId) {
      // split fields from active fields into two arrays (belonging to farm and not belonging to farm)
      var ab = _.partition(controller.uploadResponse.field.entities, function(
        e
      ) {
        return e.companyIsoId === entity.isoId;
      });

      // replace active array with fields that do not belong to farm
      controller.uploadResponse.field.entities = ab[1];

      // push fields that belong to farm onto the ignored field array
      _.each(controller.uploadResponse.field.ignored, function(e) {
        ab[0].push(e);
      });
      controller.uploadResponse.field.ignored = ab[0];
    };

    if (!match || match.id.substr(-7) === ':ignore') {
      // match ignored
      ignoreFields(); // move entity farm fields to ignored
    } else if (entity.match && entity.match.id === match.id) {
      // match deselected
      ignoreFields(); // move entity farm fields to ignored
    } else {
      // match selected
      activateFields(); // move previously ignored back to active
    }

    // finaly deselect all fields (left-hand side)
    _.each(controller.uploadResponse.field.entities, function(field) {
      delete field.$cfngrid_selected;
    }); // clear selected flag
    grids.field.clearSelection();
    controller.prepareTabHeaderStatus('field'); // reset tab header status
    // deselect all fields in ignored array
    _.each(controller.uploadResponse.field.ignored, function(field) {
      delete field.$cfngrid_selected;
    }); // clear selected flag
    // clear basedataCurrent.field
    controller.basedataCurrent.field = null;
    // and clear the basedataMatches.fields array
    controller.basedataMatches.field = null;
  };

  controller.deselectDuplicateMatchInBasedata = function(
    type,
    entityId,
    matchId
  ) {
    _.each(controller.uploadResponse[type].entities, function(entity) {
      if (matchId.substr(-4) !== ':add' && matchId.substr(-7) !== ':ignore') {
        if (
          entity.match &&
          entity.match.id === matchId &&
          entity.id !== entityId
        ) {
          entity.match = null;
        }
      }
    });
  };

  controller.gridBasedataUpdated = function(name) {
    if (name && name.substr(-5) === 'Match') {
      var type = name.substring(0, name.length - 5); // 'Match'.length == 5
      var selectedItem = controller.basedataCurrent[type];
      if (selectedItem) {
        if (selectedItem.match) {
          grids[name].setSelectedRowById(selectedItem.match.id);
        } else {
          grids[name].clearSelection();
        }
      }
    }
  };

  controller.gridTaskListUpdated = function(/*name*/) {
    controller.preselectAllTasks();
  };

  controller.onMatchTaskSelect = function(task) {
    $log.log('onMatchTaskSelect', task);
    controller.matchTaskCurrent = task;
    controller.matchOperationsCurrent = task.matches;
  };

  controller.onMatchOperationSelect = function(op) {
    if (!controller.matchTaskCurrent) return;
    $log.log('onMatchOperationSelect', op);
    if (
      controller.matchTaskCurrent.match &&
      controller.matchTaskCurrent.match.id === op.id
    ) {
      op.$cfngrid_selected = false;
      controller.matchTaskCurrent.match = null;
    } else {
      controller.matchTaskCurrent.match = op;
    }
  };

  controller.onMatchOperationUpdate = function() {
    $log.log('onMatchOperationUpdate');
    if (controller.matchTaskCurrent && controller.matchTaskCurrent.match) {
      grids.taskMatch.setSelectedRowById(controller.matchTaskCurrent.match.id);
    }
  };

  controller.onMatchOperationHoverStart = function(/*col, item, evt*/) {
    // display popup with more info
  };

  controller.onMatchOperationHoverEnd = function(/*col, item, evt*/) {
    // display popup with more info
  };

  controller.activityIconRenderer = bookingRenderService.activityIconRenderer;

  controller.basedataStatusIconRenderer = function(
    rowNumber,
    columnName,
    value,
    item
  ) {
    var status = null;

    if (!item) {
      status = basedataStati.warning; // should never occur
    } else if (!item.match) {
      // If value is null or undefined,
      // then there is no match for the item
      // and it will be ignored (not imported).
      // Display a minus sign.
      status = basedataStati.ignore;
    } else if (item.match.id && item.match.id.substr(-4) === ':add') {
      status = basedataStati.add;
    } else if (item.match.id && item.match.id.substr(-7) === ':ignore') {
      status = basedataStati.ignore;
    } else if (
      _.find(item.matches, function(match) {
        return match.id === item.match.id;
      })
    ) {
      // if match is one of the pre-calculated item matches, then display it as automatched
      status = basedataStati.automatched;
    } else {
      // otherwise, display it as manually matched.
      status = basedataStati.matched;
    }

    var result = '<div style="text-align:center;clear:both;">';
    result += '<span class="' + status.symbol + '" ';
    result += 'title="' + status.title + '"';
    result += '/>';
    result += '</div>';
    return result;
  };

  controller.matchIconRenderer = function(row, column, value) {
    if (!value) return undefined;

    var result = '<div style="text-align:center;clear:both;">';
    result += '<img ';
    result += 'style="opacity:0.7;height:18px;" ';
    result += 'src="img/icons/black/fav_active.png" ';
    result +=
      'title="' +
      $filter('i18n')('fe.core.wizards.bookingImport.matched', 'zugeordnet') +
      '"';
    result += '/>';
    result += '</div>';

    return result;
  };

  // ========== GRID FUNCTIONS END ==========

  controller.steps = [];
  controller.steps.push({
    id: 'upload',
    title: $filter('i18n')(
      'fe.core.wizards.bookingImport.uploadTitle',
      'Datei hochladen'
    ),
    help: $filter('i18n')('fe.core.wizards.bookingImport.uploadHelp'),
    enabled: true
  });
  controller.steps.push({
    id: 'basedata',
    title: $filter('i18n')(
      'fe.core.wizards.bookingImport.basedataTitle',
      'Stammdaten zuordnen'
    ),
    help: $filter('i18n')('fe.core.wizards.bookingImport.basedataHelp'),
    enabled: false
  });
  controller.steps.push({
    id: 'tasklist',
    title: $filter('i18n')(
      'fe.core.wizards.bookingImport.selectTitle',
      'Aufträge auswählen'
    ),
    help: $filter('i18n')('fe.core.wizards.bookingImport.selectHelp'),
    enabled: false
  });
  controller.steps.push({
    id: 'tasklist-errors',
    title: $filter('i18n')(
      'fe.core.wizards.bookingImport.selectErrorsTitle',
      'Aufgetretene Meldungen'
    ),
    errorBackTitle: $filter('i18n')(
      'fe.core.wizards.bookingImport.selectErrorsBack',
      'Zurück zu Aufträge auswählen'
    ),
    hidden: true
  });
  controller.steps.push({
    id: 'taskmatch',
    title: $filter('i18n')(
      'fe.core.wizards.bookingImport.matchTitle',
      'Aufträge zuordnen'
    ),
    help: $filter('i18n')('fe.core.wizards.bookingImport.matchHelp'),
    enabled: false
  });
  controller.steps.push({
    id: 'summary',
    title: $filter('i18n')(
      'fe.core.wizards.bookingImport.summaryTitle',
      'Zusammenfassung'
    ),
    help: $filter('i18n')('fe.core.wizards.bookingImport.summaryHelp'),
    enabled: false
  });
  controller.steps.push({
    id: 'summary-errors',
    title: $filter('i18n')(
      'fe.core.wizards.bookingImport.summaryErrorsTitle',
      'Aufgetretene Fehler'
    ),
    errorBackTitle: $filter('i18n')(
      'fe.core.wizards.bookingImport.summaryErrorsBack',
      'Zurück zu Zusammenfassung'
    ),
    hidden: true
  });
  controller.visibleSteps = _.filter(controller.steps, function(step) {
    return !step.hidden;
  });
  controller.visibleStepIndex = 0;
  controller.step = controller.visibleSteps[controller.visibleStepIndex]; // points to current step current step

  controller.stepForward = function() {
    controller.visibleStepIndex += 1;
    controller.step = controller.visibleSteps[controller.visibleStepIndex];
    controller.step.enabled = true;
  };

  controller.stepBack = function() {
    controller.step.enabled = false;
    if (!controller.isTasksAllowed && controller.visibleStepIndex === 4) {
      controller.visibleSteps[2].enabled = false;
      controller.visibleSteps[3].enabled = false;
      controller.visibleStepIndex = 1;
    } else {
      controller.visibleStepIndex -= 1;
    }
    controller.step = controller.visibleSteps[controller.visibleStepIndex];
  };

  controller.setStepById = function(id) {
    controller.step = _.find(controller.steps, function(step) {
      return step.id === id;
    });
  };

  controller.onFileUploaded = function(rsp) {
    controller.uploadResponse = rsp;

    // set tab header stati
    _.each(
      ['farm', 'field', 'machine', 'person', 'supply'],
      controller.prepareTabHeaderStatus
    );

    // sort entity collections, unmatched first
    _.each(['farm', 'field', 'machine', 'person', 'supply'], function(type) {
      controller.uploadResponse[type].entities = _.sortBy(
        controller.uploadResponse[type].entities,
        function(entity) {
          return (entity.match ? '1' : '0') + entity.name;
        }
      );
    });

    controller.stepForward();
  };

  controller.prepareTabHeaderStatus = function(type) {
    var status = {
      level: 'success',
      value: ' ',
      total: 0,
      matched: 0
    };
    _.each(controller.uploadResponse[type].entities, function(entity) {
      status.total++;
      if (entity.match) status.matched++;
    });

    if (status.matched !== status.total) {
      status.value = status.total - status.matched;
      status.level = 'important';
    }

    controller.status[type] = status;
  };

  controller.localActivityIconRenderer = function(value) {
    if (!value) return undefined;
    var activities = value.split(',');
    var result = '<div style="float:right;clear:both;">';
    for (var i = 0; i < activities.length; i++) {
      var name = activities[i];
      var localizedName = $filter('i18n')(
        'enums.BookingActivitiesEnum.' + name
      );
      var icon = name;
      result += '<img style="opacity:0.8;height:18px;" ';
      result +=
        'src="img/icons/black/activities/' + icon.toLowerCase() + '.png" ';
      result += 'title="' + localizedName + '"/>';
    }
    result += '</div>';
    return result;
  };

  controller.changeActivity = function(item) {
    // Handling von Activity & Template
    if (item.showTaskSelection == true) {
      _.each(controller.operations, function(step) {
        if (step.key == item.activityNo) {
          item.operation.template = step.templateName;
          item.operation.activity = step.activityName;
          item.showTaskSelection = false;
        }
      });

      if (
        item.operation.template !== null &&
        item.operation.template !== undefined
      ) {
        item.operation.activityIcons = controller.localActivityIconRenderer(
          item.operation.activity
        );
        item.showTaskSelection = false;
        // Bereinige Meldungen um Activity & Template-Themen.
        var localMessages = [];
        _.each(item.messages, function(message) {
          if (
            message.type != item.id ||
            (message.type == item.id && message.kind !== 'unknownTask')
          ) {
            localMessages.push(message);
          }
        });
        item.messages = localMessages;

        localMessages = [];
        _.each(controller.taskListResponse.messages, function(message) {
          if (
            message.type != item.id ||
            (message.type == item.id && message.kind !== 'unknownTask')
          ) {
            localMessages.push(message);
          }
        });
        controller.taskListResponse.messages = localMessages;
      }
    }

    // Handling von TaskDate
    if (item.showTaskDateSelection == true) {
      var lastYearsDateAsMilliSecs =
        new Date().getTime() - MILLISECONDS_PER_YEAR;
      if (item.taskDate !== null && item.taskDate !== undefined) {
        var _taskDate = new Date(item.taskDate);
        if (_taskDate.getTime() - lastYearsDateAsMilliSecs >= 0) {
          item.showTaskDateSelection = false;
          item.operation.date = item.taskDate;
          // Bereinige Meldungen um TaskTooOld-Themen.
          var localMessages = [];
          _.each(item.messages, function(message) {
            if (
              message.type != item.id ||
              (message.type == item.id && message.kind !== 'taskTooOld')
            ) {
              localMessages.push(message);
            }
          });
          item.messages = localMessages;

          localMessages = [];
          _.each(controller.taskListResponse.messages, function(message) {
            if (
              message.type != item.id ||
              (message.type == item.id && message.kind !== 'taskTooOld')
            ) {
              localMessages.push(message);
            }
          });
          controller.taskListResponse.messages = localMessages;
        }
      }
    }

    // Wenn beide Bedingungen positiv erfüllt sind, dann lösche Error-Markierung!
    if (item.showTaskDateSelection == true) {
      item.$cfngrid_inactive = false;
    }
    if (
      item.showTaskSelection == false &&
      item.showTaskDateSelection == false
    ) {
      item.$cfngrid_inactive = false;
      item.$cfngrid_selected = true;
      item.$cfngrid_invalid = false;

      item.redFrame = {};
    }
  };

  // Step basedata -> select
  controller.performSelect = function() {
    controller.processing = true;
    app.showLoader();

    var taskListRequest = {
      processId: controller.uploadResponse.processId,
      farm: controller.getBasedataEntityIdsAndMatchIds(
        controller.uploadResponse.farm.entities
      ),
      field: controller.getBasedataEntityIdsAndMatchIds(
        controller.uploadResponse.field.entities
      ),
      machine: controller.getBasedataEntityIdsAndMatchIds(
        controller.uploadResponse.machine.entities
      ),
      person: controller.getBasedataEntityIdsAndMatchIds(
        controller.uploadResponse.person.entities
      ),
      supply: controller.getBasedataEntityIdsAndMatchIds(
        controller.uploadResponse.supply.entities
      )
    };

    return $http({
      method: 'POST',
      url: '/365FarmNet/rest/booking/isoxml/tasklist',
      data: taskListRequest,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(
      function(response) {
        var data = response.data;
        var status = response.status;
        app.hideLoader();
        $log.log('performSelect success', status, data);
        // initially display matches from all tasks instead of a blank list

        var unknownTranslation = $filter('i18n')(
          'fe.core.wizards.bookingImport.unknown',
          'unbekannt'
        );
        _.each(data.entries, function(task) {
          if (task.operation) {
            if (!task.operation.activity) {
              task.operation.activity = '';
            }
            if (
              task.operation.activity &&
              (task.operation.activity == 'TOFERTILIZE' ||
                task.operation.activity == 'PLANTPROTECTING')
            ) {
              task.operation.activity = 'SUPPLY';
            }

            task.operation.taskDate = $filter('date')(
              task.operation.date,
              'mediumDate'
            );

            var noValidTemplate = true;
            var taskToOld = false;
            var operation = null;

            task.operation.activityIcons = '';
            task.showTaskSelection = false;
            task.showTaskDateSelection = false;
            task.taskDate = null;
            task.redFrame = {};

            if (!task.hasErrors) {
              var lastYearsDateAsMilliSecs =
                new Date().getTime() - MILLISECONDS_PER_YEAR;
              if (
                task.operation.date !== null &&
                task.operation.date !== undefined
              ) {
                var _taskDate = new Date(task.operation.date);
                if (_taskDate.getTime() - lastYearsDateAsMilliSecs <= 0) {
                  var taskMessageDates = $filter('i18n')(
                    'fe.core.wizards.bookingImport.taskTooOld',
                    'Der Auftrag ist älter als 1 Jahr!'
                  );
                  task.showTaskDateSelection = true;
                  task.taskDate = _taskDate.getTime();
                  task.redFrame = {
                    'border-width': '3px',
                    'border-style': 'solid',
                    'border-color': 'red'
                  };

                  if (!task.messages) {
                    task.messages = [];
                  }
                  task.messages.push({
                    message: taskMessageDates,
                    type: task.id,
                    kind: 'taskTooOld'
                  });

                  if (!data.messages) {
                    data.messages = [];
                  }

                  data.messages.push({
                    message: taskMessageDates,
                    type: task.id,
                    kind: 'taskTooOld'
                  });
                  task.$cfngrid_inactive = false;
                  task.$cfngrid_selected = false;
                  task.$cfngrid_invalid = true;
                }
              }

              // CFNPOC-7684
              // check if the template is valid
              // usually there is a template
              // but could be renamed, deleted etc.
              for (var i = 0; i < controller.operations.length; i++) {
                operation = controller.operations[i];
                if (task.operation.template === operation.templateName) {
                  // found a matching template
                  noValidTemplate = false;
                  // take the first - templateNames are unique?
                  break;
                }
              }

              if (noValidTemplate) {
                var taskMessage =
                  $filter('i18n')(
                    'fe.core.wizards.bookingImport.unknownTask',
                    'unbekannte Tätigkeit:'
                  ) +
                  ' ' +
                  task.operation.template;
                task.operation.activity = '';
                task.showTaskSelection = true;
                task.redFrame = {
                  'border-width': '3px',
                  'border-style': 'solid',
                  'border-color': 'red'
                };

                if (!task.messages) {
                  task.messages = [];
                }
                task.messages.push({
                  message: taskMessage,
                  type: task.id,
                  kind: 'unknownTask'
                });

                if (!data.messages) {
                  data.messages = [];
                }

                data.messages.push({
                  message: taskMessage,
                  type: task.id,
                  kind: 'unknownTask'
                });
                task.$cfngrid_inactive = true;
                task.$cfngrid_selected = false;
                task.$cfngrid_invalid = true;
              } else {
                task.operation.activityIcons = controller.localActivityIconRenderer(
                  task.operation.activity
                );
                task.$cfngrid_selected = true;
              }
            }

            if (task.hasErrors) {
              task.$cfngrid_invalid = true;
              task.$cfngrid_inactive = true;
              task.$cfngrid_selected = false; //NZ
            }

            if (!task.operation.field)
              task.operation.field = unknownTranslation;
            if (!task.operation.person)
              task.operation.person = unknownTranslation;
            if (!task.operation.machine)
              task.operation.machine = unknownTranslation;
            if (!task.operation.supply)
              task.operation.supply = unknownTranslation;
            task.operation.activity = task.operation.activity.replace(
              '***',
              ''
            );
            task.operation.field = task.operation.field.replace('***', '');
            task.operation.person = task.operation.person.replace('***', '');
            task.operation.machine = task.operation.machine.replace('***', '');
            task.operation.supply = task.operation.supply.replace('***', '');
          }
        });

        controller.taskListResponse = data;
        $log.log('taskListResponse set');
        controller.processing = false;

        controller.stepForward();

        // after model updated, preselect all non-error tasks and mark error tasks as such
      },
      function(response) {
        app.hideLoader();
        $log.log('performSelect error', response.status, response.data);
        controller.error = $filter('i18n')(
          'fe.core.wizards.bookingImport.generalError',
          'Es ist ein Fehler aufgetreten'
        );
        controller.processing = false;
      }
    );
  };

  controller.preselectAllTasks = function() {
    // called from gridTaskSelectUpdated - linked in html to aftermodelupdate event
    $log.log('preselectAllTasks');

    if (controller.taskListResponse && controller.taskListResponse.entries) {
      _.each(controller.taskListResponse.entries, function(task) {
        if (task.hasErrors) {
          task.$cfngrid_invalid = true;
          task.$cfngrid_inactive = true;
        } else {
          task.$cfngrid_selected = true; //NZ
        }
      });
    }
  };

  controller.updateTasksAllowed = function() {
    $http({
      method: 'GET',
      url: '/365FarmNet/rest/booking/isoxml/tasksallowed'
    }).then(
      function(response) {
        controller.isTasksAllowed = response.data;
      },
      function(response) {
        $log.log('updateTasksAllowed error', response.status, response.data);
      }
    );
  };

  controller.updateTasksAllowed();

  // Step select -> match
  controller.performMatch = function() {
    controller.processing = true;
    app.showLoader();
    var taskMatchRequest = {
      processId: controller.uploadResponse.processId,
      farm: controller.getBasedataEntityIdsAndMatchIds(
        controller.uploadResponse.farm.entities
      ),
      field: controller.getBasedataEntityIdsAndMatchIds(
        controller.uploadResponse.field.entities
      ),
      machine: controller.getBasedataEntityIdsAndMatchIds(
        controller.uploadResponse.machine.entities
      ),
      person: controller.getBasedataEntityIdsAndMatchIds(
        controller.uploadResponse.person.entities
      ),
      supply: controller.getBasedataEntityIdsAndMatchIds(
        controller.uploadResponse.supply.entities
      ),
      task: controller.getSelectedTasksResponseEntries() // array of task ids, activity, template
    };

    return $http({
      method: 'POST',
      url: '/365FarmNet/rest/booking/isoxml/taskmatch',
      data: taskMatchRequest,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(
      function(response) {
        var data = response.data;
        var status = response.status;
        app.hideLoader();
        $log.log('performMatch success', status, data);

        controller.taskMatchResponse = data;

        // initially display matches from all tasks instead of a blank list
        controller.matchOperationsCurrent = _.reduce(
          data.entries,
          function(result, task) {
            return task.matches ? result.concat(task.matches) : result;
          },
          []
        );

        // do not display multiple time the same planning, while only belonging to one field
        controller.matchOperationsCurrent = $filter('unique')(
          controller.matchOperationsCurrent,
          'id'
        );

        controller.processing = false;
        controller.stepForward();
      },
      function(response) {
        app.hideLoader();
        $log.log('performMatch error', response.status, response.data);
        controller.error = $filter('i18n')(
          'fe.core.wizards.bookingImport.generalError',
          'Es ist ein Fehler aufgetreten'
        );
        controller.processing = false;
      }
    );
  }; // perform match

  controller.performImport = function() {
    controller.processing = true;
    app.showLoader();

    var entries = [];

    _.each(controller.taskMatchResponse.entries, function(task) {
      entries.push({
        id: task.id,
        activity: task.operation.activity,
        template: task.operation.template,
        matchId: task.match ? task.match.id : null
      });
    });

    var importRequest = {
      processId: controller.taskMatchResponse.processId,
      entries: entries
    };

    return $http({
      method: 'POST',
      url: '/365FarmNet/rest/booking/isoxml/import',
      data: importRequest,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(
      function(response) {
        var rsp = response.data;
        var status = response.status;
        app.hideLoader();
        controller.processing = false;
        if (Number(status) === 200 && rsp) {
          if (rsp.messages && rsp.messages.length === 0) rsp.messages = null;
          controller.importResponse = rsp;
          controller.importResponse.ok = true;
          $rootScope.$broadcast('#BookingAdded'); // notify BookingController of new bookings
        } else {
          controller.error = $filter('i18n')(
            'fe.core.wizards.bookingImport.generalError',
            'Es ist ein Fehler aufgetreten'
          );
        }
      },
      function(response) {
        app.hideLoader();
        $log.log('performImport error', response.status, response.data);
        controller.error = $filter('i18n')(
          'fe.core.wizards.bookingImport.generalError',
          'Es ist ein Fehler aufgetreten'
        );
        controller.processing = false;
      }
    );
  }; // perform import

  controller.getBasedataEntityIdsAndMatchIds = function(entities) {
    var result = [];
    _.each(entities, function(entity) {
      if (entity.match && entity.match.id.substr(-7) !== ':ignore') {
        var matchId = entity.match.id;
        if (matchId.substr(-4) === ':add') matchId = null;
        result.push({ id: entity.id, isoId: entity.isoId, matchId: matchId });
      }
    });
    return result;
  };

  controller.getSelectedTasksResponseEntries = function() {
    return _.reduce(
      _.filter(controller.taskListResponse.entries, function(entry) {
        return entry.$cfngrid_selected;
      }),
      function(result, entry) {
        result.push({
          id: entry.id,
          activity: entry.operation.activity,
          template: entry.operation.template,
          operationdate: entry.taskDate
        });
        return result;
      },
      []
    );
  };

  controller.skipToSummaryBecauseTasksNotAllowed = function() {
    if (!controller.isTasksAllowed) {
      controller.taskMatchResponse = { entries: [] };
      controller.performMatch().finally(controller.prepareSummary);
      return true;
    }
    return false;
  };

  controller.canSkipFromBasedataToSummary = function() {
    // if no tasks are in the isoxml file, skip the two task steps (select and match) and go directly to summary
    return _.size(controller.taskListResponse.entries) === 0;
  };

  controller.canSkipFromSelectToSummary = function() {
    // if no tasks are selected, skip the match step and go directly to summary
    return _.size(controller.getSelectedTasksResponseEntries()) === 0;
  };

  controller.resetImportResponse = function() {
    var countAdded = function(item) {
      return item.match && item.match.id.substr(-4) === ':add';
    };

    var countTotal = function(item) {
      if (item.match) {
        return item.match.id.substr(-7) !== ':ignore';
      } else {
        return true;
      }
    };

    controller.importResponse = {
      summary: {
        farm: {
          total: _.size(
            _.filter(controller.uploadResponse.farm.entities, countTotal)
          ),
          added: _.size(
            _.filter(controller.uploadResponse.farm.entities, countAdded)
          )
        },
        field: {
          total: _.size(
            _.filter(controller.uploadResponse.field.entities, countTotal)
          ),
          added: _.size(
            _.filter(controller.uploadResponse.field.entities, countAdded)
          )
        },
        machine: {
          total: _.size(
            _.filter(controller.uploadResponse.machine.entities, countTotal)
          ),
          added: _.size(
            _.filter(controller.uploadResponse.machine.entities, countAdded)
          )
        },
        person: {
          total: _.size(
            _.filter(controller.uploadResponse.person.entities, countTotal)
          ),
          added: _.size(
            _.filter(controller.uploadResponse.person.entities, countAdded)
          )
        },
        supply: {
          total: _.size(
            _.filter(controller.uploadResponse.supply.entities, countTotal)
          ),
          added: _.size(
            _.filter(controller.uploadResponse.supply.entities, countAdded)
          )
        },
        tasksMatch: {
          total: _.size(
            _.filter(controller.taskMatchResponse.entries, function(task) {
              return task.match;
            })
          )
        },
        tasksPre: {
          total: _.size(
            _.filter(controller.taskMatchResponse.entries, function(task) {
              return !task.match;
            })
          )
        }
      }
    };

    controller.importResponse.total = _.reduce(
      controller.importResponse.summary,
      function(result, item) {
        result += item.total;
        return result;
      },
      0
    );
  };

  // Step match -> summary
  controller.prepareSummary = function() {
    controller.resetImportResponse();
    controller.stepForward();
  }; // prepare summary

  //  Step upload -> basedata
  controller.performUpload = function() {
    controller.processing = true;
    app.showLoader();
    if (controller.importFile !== null) {
      uploader.start(); // start uploader
    } else if (controller.selectedDataSetUuid !== null) {
      BookinIsoXmlHttp.importDataSet(controller.selectedDataSetUuid)
        .then(function(response) {
          controller.onFileUploaded(response);
        })
        .finally(function() {
          if (!controller.uploadResponse.processId) {
            controller.error = $filter('i18n')(
              'fe.core.wizards.bookingImport.generalError',
              'Es ist ein Fehler aufgetreten'
            );
          }
          app.hideLoader();
          controller.processing = false;
        });
    }
  };

  controller.importData = function() {
    controller.close('import');
  };

  controller.nextAction = function() {
    controller.errorListVisible = false;
    if (controller.step.id === 'upload') {
      controller.performUpload();
    } else if (controller.step.id === 'basedata') {
      controller.performSelect().then(function() {
        if (
          !controller.skipToSummaryBecauseTasksNotAllowed() &&
          controller.canSkipFromBasedataToSummary()
        ) {
          $rootScope.alertController.addTemporaryAlert(
            i18n(
              'fe.core.wizards.bookingImport.skiptasks',
              'Keine Aufträge vorhanden.'
            ),
            'info'
          );
          controller.performMatch().finally(controller.prepareSummary);
        }
      });
    } else if (controller.step.id === 'tasklist') {
      controller.performMatch().finally(function() {
        if (controller.canSkipFromSelectToSummary()) {
          controller.prepareSummary();
        }
      });
    } else if (controller.step.id === 'taskmatch') {
      controller.prepareSummary();
    } else if (controller.step.id === 'summary') {
      if (controller.importResponse && controller.importResponse.ok) {
        controller.close('ok');
      } else {
        controller.performImport();
      }
    }
  };

  controller.nextActionFendt = function() {
    controller.errorListVisible = false;
    if (controller.step.id === 'upload') {
      controller.processing = true;
      app.showLoader();
      $http({
        method: 'POST',
        url: '/365FarmNet/rest/booking/isoxml/dummyfile'
      }).then(
        function(response) {
          var data = response.data;
          var rsp = data;
          if (rsp) {
            controller.uploadResponse = rsp;

            // set tab header status
            _.each(
              ['farm', 'field', 'machine', 'person', 'supply'],
              controller.prepareTabHeaderStatus
            );

            // sort entity collections, unmatched first
            _.each(['farm', 'field', 'machine', 'person', 'supply'], function(
              type
            ) {
              controller.uploadResponse[type].entities = _.sortBy(
                controller.uploadResponse[type].entities,
                function(entity) {
                  return (entity.match ? '1' : '0') + entity.name;
                }
              );
            });
            controller.stepForward();
          }
        },
        function() {
          controller.error = $filter('i18n')(
            'fe.core.wizards.bookingImport.generalError',
            'Es ist ein Fehler aufgetreten'
          );
        }
      );
      app.hideLoader();
      controller.processing = false;
      controller.showMachines = 0;
    } else if (controller.step.id === 'basedata') {
      controller.performSelect().then(function() {
        if (
          !controller.skipToSummaryBecauseTasksNotAllowed() &&
          controller.canSkipFromBasedataToSummary()
        ) {
          $rootScope.alertController.addTemporaryAlert(
            i18n(
              'fe.core.wizards.bookingImport.skiptasks',
              'Keine Aufträge vorhanden.'
            ),
            'info'
          );
          controller.performMatch().finally(controller.prepareSummary);
        }
      });
    } else if (controller.step.id === 'tasklist') {
      controller.performMatch().finally(function() {
        if (controller.canSkipFromSelectToSummary()) {
          controller.prepareSummary();
        }
      });
    } else if (controller.step.id === 'taskmatch') {
      controller.prepareSummary();
    } else if (controller.step.id === 'summary') {
      if (controller.importResponse && controller.importResponse.ok) {
        controller.close('ok');
      } else {
        controller.performImport();
      }
    }
  };

  controller.previousAction = function() {
    controller.errorListVisible = false;

    if (controller.step.id === 'basedata') {
      controller.showMachines = 1;
      controller.error = null;
      controller.tab.farm = true;
      controller.basedataCurrent = {};
      controller.basedataMatches = {};
      controller.stepBack();
      controller.uploadResponse = null;
      controller.importFile = null;
      controller.dataSets = [];
      controller.hasFendtCredentials = false;
      controller.selectedDataSetUuid = null;
      controller.dataSetsLoad();
    } else if (controller.step.id === 'tasklist') {
      controller.error = null;
      controller.stepBack();
    } else if (controller.step.id === 'taskmatch') {
      controller.error = null;
      controller.stepBack();
      grids.task.clearSelection();
      controller.matchOperationsCurrent = [];
    } else if (controller.step.id === 'summary') {
      controller.error = null;
      if (controller.importResponse && controller.importResponse.ok) {
        controller.resetImportResponse();
      } else {
        controller.stepBack();
      }
    } else {
      controller.error = null;
      controller.stepBack();
    }
  };

  controller.showErrors = function() {
    var id = controller.step.id + '-errors';
    controller.setStepById(id);
    controller.errorListVisible = true;
  };

  controller.hideErrors = function() {
    var id = controller.step.id.split('-')[0];
    controller.setStepById(id);
    controller.errorListVisible = false;
  };

  controller.errorListButtonVisible = function() {
    return (
      controller.error === null &&
      !controller.errorListVisible &&
      ((controller.step.id === 'tasklist' &&
        controller.taskListResponse &&
        controller.taskListResponse.messages) ||
        (controller.step.id === 'summary' &&
          controller.importResponse &&
          controller.importResponse.messages))
    );
  };

  controller.nextLabel = function() {
    if (
      controller.step.id === 'summary' ||
      controller.step.id === 'summary-errors'
    ) {
      if (controller.importResponse && controller.importResponse.ok) {
        return $filter('i18n')('fe.common.close', 'Schließen');
      } else {
        return $filter('i18n')('fe.common.import', 'Importieren');
      }
    } else {
      return $filter('i18n')('fe.common.nextLabel', 'Weiter');
    }
  };

  controller.nextDisabledFendt = function() {
    if (controller.processing || controller.errorListVisible) {
      return true;
    } else if (controller.step.id === 'upload') {
      if (controller.serienNr) {
        controller.info = '';
        return false;
      } else {
        controller.info = $filter('i18n')(
          'fe.core.wizards.isoImport.info',
          'bitte eine Maschine auswählen.'
        );
        return true;
      }
    } else if (controller.step.id === 'basedata') {
      // Validation removed
      return false;
    } else if (controller.step.id === 'tasklist') {
      return false; //_.isEmpty(controller.getSelectedTasksResponseEntries());
    } else if (
      controller.step.id === 'summary' &&
      controller.importResponse &&
      controller.importResponse.ok
    ) {
      return false;
    } else if (
      controller.step.id === 'summary' &&
      controller.importResponse.summary
    ) {
      return controller.importResponse.summary.total === 0;
    }
    return false;
  };

  controller.nextDisabled = function() {
    if (controller.processing || controller.errorListVisible) {
      return true;
    } else if (controller.step.id === 'upload') {
      return (
        controller.importFile === null &&
        controller.selectedDataSetUuid === null
      );
    } else if (controller.step.id === 'basedata') {
      // Removed validation
      return false;
    } else if (controller.step.id === 'tasklist') {
      return false; //_.isEmpty(controller.getSelectedTasksResponseEntries());
    } else if (
      controller.step.id === 'summary' &&
      controller.importResponse &&
      controller.importResponse.ok
    ) {
      return false;
    } else if (
      controller.step.id === 'summary' &&
      controller.importResponse.summary
    ) {
      return controller.importResponse.summary.total === 0;
    }
    return false;
  };

  controller.previousDisabled = function() {
    return (
      controller.processing ||
      controller.step.id === 'upload' ||
      controller.step.id === 'tasklist-errors' ||
      controller.step.id === 'summary-errors' ||
      (controller.step.id === 'summary' &&
        controller.importResponse &&
        controller.importResponse.ok)
    );
  };

  controller.cancelDisabled = function() {
    return (
      (controller.step.id === 'summary' &&
        controller.importResponse &&
        controller.importResponse.ok) ||
      controller.step.id === 'summary-errors'
    );
  };

  controller.close = function(action) {
    dialog.close({ action: action });
  };

  return app.farmnetControllers.finishController(
    'bookingImportWizardController',
    $scope,
    this,
    $injector
  );

  function initializeUploader() {
    // Prepare Step 1: Upload
    uploader = new plupload.Uploader({
      runtimes: 'html5',
      browse_button: 'btnBookingImport',
      container: 'pnlBookingImport',
      max_file_size: '10mb',
      url: '/365FarmNet/rest/booking/isoxml/upload',
      filters: [{ title: 'TASKDATA', extensions: 'xml' }],
      multi_selection: false
    });

    uploader.init();

    uploader.bind('FilesAdded', function(up, files) {
      $scope.$apply(function() {
        controller.importFile = null;
        controller.error = null;
        if (files && files.length > 0) {
          //controller.importFile = files[0].name;
          controller.importFile = files[0].name;
        }
      });
    });

    uploader.bind('Error', function(up, err) {
      $scope.$apply(function() {
        if (err.code === -600) {
          controller.error = $filter('i18n')(
            'fe.core.wizards.bookingImport.fileTooBig',
            'Die Dateigröße überschreitet das Limit von {0}',
            '10 MByte'
          );
        } else if (err.status === 422) {
          controller.error = $filter('i18n')(
            'fe.core.wizards.bookingImport.syntaxError',
            'Die Datei kann aufgrund von Syntaxfehlern nicht eingelesen werden.'
          );
        } else {
          controller.error = $filter('i18n')(
            'fe.core.wizards.bookingImport.generalError',
            'Es ist ein Fehler aufgetreten'
          );
        }
        app.hideLoader();
        controller.uploadResponse = null;
        controller.importFile = null;
        controller.processing = false;
      });
    });

    uploader.bind('FileUploaded', function(up, file, response) {
      $scope.$apply(function() {
        if (response && response.response) {
          var rsp = JSON.parse(response.response);
          if (rsp) {
            controller.onFileUploaded(rsp);
          }
        }
        if (!controller.uploadResponse.processId) {
          controller.error = $filter('i18n')(
            'fe.core.wizards.bookingImport.generalError',
            'Es ist ein Fehler aufgetreten'
          );
        }
        app.hideLoader();
        controller.processing = false;
      }); // $scope.$apply
    });
  }
}
